import { NgModule } from '@angular/core';
import { CurrencyNamePipe } from 'app/pipes/currency-name/currency-name.pipe';

@NgModule({
    declarations: [CurrencyNamePipe],
    providers: [CurrencyNamePipe],
    exports: [CurrencyNamePipe],
})
export class CurrencyNamePipeModule {
}